import { FILE_ICONS } from '~/eds/src/constants/file';
import { getFileExtension } from '~/eds/src/utils/getFileExtension';

import { EnrichedGroupNode } from './NodeEnricher/NodeEnricher';
import { TreeBrowserNode } from './TreeBrowser/types';

export type ResourceType = 'document' | 'ticket' | 'group' | string;

export interface GetResourceIconParams {
  resourceType: ResourceType;
  filename?: string;
  fileType?: string;
}

export const getResourceIcon = ({
  resourceType,
  filename,
  fileType,
}: GetResourceIconParams) => {
  const extension = fileType ?? (filename && getFileExtension(filename));
  const documentIconName = FILE_ICONS[extension ?? ''] ?? 'file';

  switch (resourceType) {
    case 'ticket':
      return 'file-pen';
    case 'document':
      return documentIconName;
    default:
      return 'file';
  }
};

export const getNodeIconName = (node: TreeBrowserNode<EnrichedGroupNode>) => {
  return getResourceIcon({
    resourceType: node.attributes.resourceType,
    filename: node.enrichedFields?.documentCurrentVersionName,
    fileType: node.enrichedFields?.fileType,
  });
};
